export default "https://fiverr-res.cloudinary.com/npm-assets/layout-service/unilever.0abe2c7.svg";